import { useRouter } from 'next/router';

import { omit } from '~/src/common/utils/object';
import { AddProductBodyProductSource } from '~/src/queries/api-ecom/generated/api-ecom.schemas';
import { CatalogContentLinkQueryParams } from '~/src/screens/CatalogContent/ContentScreen/types';

type CurrentSource = Extract<
  AddProductBodyProductSource,
  { type: 'main product' | 'essentials recipe ingredients list' | 'recipe ingredients list' }
>;

const useCatalogContentSource = (currentSource: CurrentSource) => {
  const { query } = useRouter<CatalogContentLinkQueryParams>();
  const sourceData = omit(query, [
    'category',
    'subcategory',
    'eventSource',
    'categorySlug',
    'slug',
    'type',
  ]);
  const filteredSourceData = Object.fromEntries(
    Object.entries(sourceData).filter(([, value]) => value !== undefined),
  );

  const source: AddProductBodyProductSource = {
    type: currentSource.type,
    // @ts-expect-error - La valeur vient de l'url, typage strict impossible
    detail: {
      ...currentSource.detail,
      ...(query.type
        ? {
            from: {
              type: query.type,
              detail: {
                ...(Object.keys(filteredSourceData).length > 0 ? filteredSourceData : {}),
              },
            },
          }
        : {}),
    },
  };

  return source;
};

export default useCatalogContentSource;
